import { render, staticRenderFns } from "./ESGModuleScopeWiseTable.vue?vue&type=template&id=3cab07de"
import script from "./ESGModuleScopeWiseTable.vue?vue&type=script&lang=js"
export * from "./ESGModuleScopeWiseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports